// components/ErrorModal.jsx - Functional Error Modal
import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';

const ErrorModal = ({ show, onHide, message }) => {
  return (
    <Modal show={show} onHide={onHide} style={{ zIndex: '10000000000' }}>
      <Modal.Body className={'rtl'} style={{ fontSize: '.9rem' }}>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Row style={{ width: '100%', margin: '0px' }}>
          <Col style={{ width: '50%', padding: '0px 5px' }}>
            <button className='btn-success border-0 color-white rounded p-2' onClick={onHide} style={{ width: '100%' }}>
              <span>متوجه شدم</span>
            </button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
